import { FC } from "react"
import { useTranslation } from "react-i18next"
import styles from "./StatBlock.module.scss"
import { IStatBlockProps } from "./types"

export const StatBlock: FC<IStatBlockProps> = ({ title, rows }) => {
  const { t } = useTranslation("catalog")

  if (rows.length === 0) {
    return null
  }

  return (
    <section className={styles.StatBlock}>
      <h3 className={styles.StatBlock_title}>{title}</h3>
      <ul className={styles.StatBlock_rows}>
        {rows.map((row) => (
          <li key={row.code} className={styles.StatBlock_row}>
            <span>{t(`stat.${row.code}`, { defaultValue: row.code })}</span>
            <span>{row.formatted}</span>
          </li>
        ))}
      </ul>
    </section>
  )
}
